import { translateFn } from 'apps/webcomponents/src/utils/translator.helper';
import { LitElement, html, PropertyValues } from 'lit';
import { property, customElement, query } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { FontSizes } from '../../../../../types/common/types';
import {
  API_TYPE_INTEGRATION_PROFILES_FOR_VMWARE,
  WEB_COMPONENT_SET_VMWARE_INTEGRATOR
} from '../../../../../webcomponents.constants';
import { GzFormFieldWebComponent } from '../../../../../ui/gzForm/formField';
import {GzSingleSelectComplexWebComponent} from "../../../../../ui/gzSingleSelectComplex";
import {GetItemsResponse} from "../../../../../ui/gzSingleSelectComplex/types";
import { NetworkPopUpEvents } from '../../NetworkBasePopUp';

@customElement(WEB_COMPONENT_SET_VMWARE_INTEGRATOR)
export class SetVmwareIntegratorWebComponent extends LitElement {
  @property({ type: String, attribute: true, reflect: true })
  message = '';

  @property({ type: String, attribute: true, reflect: true })
  endpointCompanyId = '';

  @query('gz-form-field#integration-instances')
  integrationInstances: GzFormFieldWebComponent<GzSingleSelectComplexWebComponent, string | number>;

  static get styles() {
    return styles;
  }

  render() {
    return html`
      <div class = "container">
        <gz-text
          fontSize="${FontSizes.HEADING_6}"
          .innerHTML= ${this.message}>
        </gz-text>

        <div>
          <gz-form-field id='integration-instances' class="mt-2 mb-2" label="${translateFn('vCenter profile card')}" >
            <gz-single-select-complex
              gz-form-input
              labelWidth='240'
              @selectionChange=${this.handleDropdownValueChanged}
            ></gz-single-select-complex>
          </gz-form-field>
        </div>

      </div>
    `;
  }

  firstUpdated(_changedProperties: PropertyValues) {
    super.firstUpdated(_changedProperties);
    this.configureIntegrationInstances();
  }

  public getFormValue(): string | number {
    return this.integrationInstances.value;
  }

  private handleDropdownValueChanged(event: CustomEvent) {
    this.dispatchEvent(
      new CustomEvent(NetworkPopUpEvents.SET_CONFIRM_BUTTON, {
        bubbles: true,
        detail: {
          value: !event.detail.selectedValue,
        },
      })
    );
  }

  private configureIntegrationInstances() {
    if (this.integrationInstances && this.integrationInstances.Input) {
      this.integrationInstances.Input.placeholder = translateFn('Select profile');
      this.integrationInstances.Input.searchPlaceholderString = translateFn('Search');
      this.integrationInstances.Input.noSearchResultsString = translateFn('No options found');
      this.integrationInstances.Input.setApiType(API_TYPE_INTEGRATION_PROFILES_FOR_VMWARE);

      const selectedValues: GetItemsResponse = {
        items: [],
        totalItemsCount: 0,
        context: {
          companyId: this.endpointCompanyId
        }
      };

      // update the dropdown list at initialization
      this.integrationInstances.Input.updateComplete.then(() => {
        this.integrationInstances.Input.controller.setFilterOptions(selectedValues);
      });
    }
  }

  constructor(endpointCompanyId: string) {
    super();
    this.endpointCompanyId = endpointCompanyId;
    this.message = translateFn('Select a preferred VMware vCenter integration profile card. To create a new one, {break}' +
      'go to the Integrations hub and select Configure under Integrations Catalog > ' +
      'VMware vCenter.',
      {
        break: '<br>'
      }
    );
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'gz-set-vmware-integrator': SetVmwareIntegratorWebComponent;
  }
}
